import { PropsWithChildren, ReactNode, useMemo } from 'react';
import styles from './SingleAssetSubPage.module.scss';
import { useTranslation } from 'react-i18next';
import TextInfo from '@customer/components/asset-data/text-info/TextInfo';
import TimeInfo from '@customer/components/asset-data/time-info/TimeInfo';

export interface HeaderItem {
  titleTransId: string;
  value?: string;
  isTime?: boolean;
}

interface SingleAssetSubPageProps {
  headerItems?: HeaderItem[];
  headerActions?: ReactNode;
}

export const SingleAssetSubPage = ({
  headerItems,
  headerActions,
  children,
}: PropsWithChildren<SingleAssetSubPageProps>) => {
  const { t } = useTranslation();

  const headerItemNodes = useMemo(() => {
    if (headerItems) {
      const nodes = headerItems.map((item, index) =>
        item.isTime ? (
          <TimeInfo key={index} label={t(item.titleTransId)} timestamp={item.value} />
        ) : (
          <TextInfo key={index} label={t(item.titleTransId)} value={item.value} />
        ),
      );

      return <div className={styles.header__items}>{nodes}</div>;
    }

    return null;
  }, [headerItems, t]);

  return (
    <article className={styles.subpage}>
      {(headerItemNodes || headerActions) && (
        <header className={styles.header}>
          {headerItemNodes}
          {headerActions}
        </header>
      )}

      <div className={styles.content}>{children}</div>
    </article>
  );
};

export default SingleAssetSubPage;
